<script setup lang="ts">
import Button from '@components/Button.vue';
import Icon from '@components/Icon.vue';
import { IconPlus, IconMinus } from '@icons';

const emit = defineEmits<{(e: 'zoom-in'): void, (e: 'zoom-out'): void}>();
</script>

<template>
  <div class="zoom-map-buttons">
    <Button
      variant="white"
      class="zoom-map-buttons__button !rounded-b-none !border-b-0"
      @click.native="emit('zoom-in')"
    >
      <Icon
        :svg="IconPlus"
        width="24"
        height="24"
      />
    </Button>

    <Button
      variant="white"
      class="zoom-map-buttons__button !rounded-t-none border-t border-solid border-gray"
      @click.native="emit('zoom-out')"
    >
      <Icon
        :svg="IconMinus"
        width="24"
        height="24"
      />
    </Button>
  </div>
</template>

<style lang="scss" scoped>
.zoom-map-buttons {
  @apply border-0;

  @apply flex flex-col;

  &__button {
    @apply size-10;

    @apply p-0;

    @apply flex items-center justify-center;
  }
}
</style>
